module.exports = __webpack_public_path__ + "img/13-min.07296f84.jpg";